import { createReducer, on } from '@ngrx/store';

import { ClearInstanceData } from '../actions/instances.actions';
import { SessionLogoutSuccessfull } from '../actions/session.actions';
import { SetWorkflow, SetWorkflowLoading } from '../actions/workflow.actions';
import { workflowState } from '../states/workflow.state';

export const WORKFLOW_REDUCER_KEY = 'workflows';

export const WORKFLOW_REDUCER = createReducer(
    workflowState,
    on(SetWorkflow, (state, action) => {
        return {
            ...state,
            instanceIdVsWorkflowState: {
                ...state.instanceIdVsWorkflowState,
                [action.instanceId]: action.workflows,
            },
        };
    }),
    on(ClearInstanceData, (state, action) => {
        return {
            ...state,
            instanceIdVsWorkflowState: {
                ...state.instanceIdVsWorkflowState,
                [action.instanceId]: undefined,
            },
        };
    }),
    on(SetWorkflowLoading, (state, action) => {
        return {
            ...state,
            loading: {
                ...state.loading,
                ...action.instanceIds.reduce((loadingMap, id) => {
                    loadingMap[id] = action.loading;
                    return loadingMap;
                }, {}),
            },
        };
    }),
    on(SessionLogoutSuccessfull, () => workflowState)
);
